import React from 'react';
import { Box } from '@mui/material';
import TeamImportViaCSV from 'team/components/leads/importLeads/TeamImportViaCSV';

const TeamImportLeadsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <TeamImportViaCSV />
        </Box>
    );
};

export default TeamImportLeadsContainer;
